import React from "react";

const MAP = {
  // greens
  approved: "ok", active: "ok", confirmed: "ok", verified: "ok", paid: "ok",
  completed: "ok", delivered: "ok", closed: "ok", "fully fulfilled": "ok", ok: "ok",
  // ambers
  "pending approval": "warn", "under review": "warn", requested: "warn",
  received: "warn", draft: "neutral", open: "warn", issued: "warn",
  "partially fulfilled": "warn", "do issued": "info", authorized: "info",
  // reds
  rejected: "bad", suspended: "bad", expired: "bad", cancelled: "bad", failed: "bad",
  resolved: "ok",
};

const CLS = {
  ok: "bg-emerald-50 text-emerald-700 border-emerald-200",
  warn: "bg-orange-50 text-orange-700 border-orange-200",
  bad: "bg-rose-50 text-rose-700 border-rose-200",
  info: "bg-sky-50 text-sky-700 border-sky-200",
  neutral: "bg-slate-100 text-slate-600 border-slate-200",
};

export default function StatusBadge({ status }) {
  if (!status) return <span className="text-slate-400">—</span>;
  const kind = MAP[String(status).toLowerCase()] || "neutral";
  return (
    <span
      data-testid={`badge-status-${String(status).toLowerCase().replace(/\s+/g, "-")}`}
      className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[11px] font-semibold ${CLS[kind]}`}
    >
      {status}
    </span>
  );
}

export function SeverityBadge({ level }) {
  const cls = { Low: CLS.info, Medium: CLS.warn, High: CLS.bad, Critical: CLS.bad }[level] || CLS.neutral;
  return <span className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[11px] font-semibold ${cls}`}>{level}</span>;
}

export function RiskBadge({ level }) {
  return <SeverityBadge level={level} />;
}
